export const COVER_EPISODE_MODES = {
  NONE: 'NONE',
  AUTO_INDEX: 'AUTO_INDEX',
};
